import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Lock, Mail, ShieldCheck } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const formatErr = (detail) => {
  if (!detail) return 'Giriş başarısız.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(' ');
  return String(detail);
};

const AdminLogin = () => {
  const { user, login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      navigate('/admin');
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0c0c0c] via-[#1a1408] to-[#0c0c0c] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#b8860b]/10 border border-[#b8860b]/30 mb-6">
            <ShieldCheck className="w-7 h-7 text-[#d4af37]" />
          </div>
          <h1 className="text-white text-3xl font-light tracking-[0.2em] uppercase">Yönetici Paneli</h1>
          <p className="text-white/50 text-sm mt-3 tracking-wide">Altınzade Kuyumculuk · Admin Login</p>
        </div>

        <form onSubmit={onSubmit} className="bg-[#141414] border border-[#2a2a2a] p-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-white/70 text-xs tracking-widest uppercase mb-2">E-posta</label>
            <div className="relative">
              <Mail className="w-4 h-4 text-[#b8860b] absolute left-4 top-1/2 -translate-y-1/2" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="admin-login-email"
                className="w-full bg-[#0a0a0a] border border-[#2a2a2a] focus:border-[#b8860b] text-white text-sm pl-11 pr-4 py-3 outline-none transition-colors"
                placeholder="email@altinzadekuyumculuk.com"
              />
            </div>
          </div>

          <div>
            <label className="block text-white/70 text-xs tracking-widest uppercase mb-2">Şifre</label>
            <div className="relative">
              <Lock className="w-4 h-4 text-[#b8860b] absolute left-4 top-1/2 -translate-y-1/2" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="admin-login-password"
                className="w-full bg-[#0a0a0a] border border-[#2a2a2a] focus:border-[#b8860b] text-white text-sm pl-11 pr-4 py-3 outline-none transition-colors"
                placeholder="••••••••"
              />
            </div>
          </div>

          {error && (
            <div data-testid="admin-login-error" className="text-red-400 text-xs tracking-wide bg-red-500/5 border border-red-500/20 px-4 py-3">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-[#b8860b] hover:bg-[#d4af37] disabled:opacity-50 text-black text-sm font-medium tracking-widest uppercase py-4 transition-colors"
          >
            {loading ? 'Giriş yapılıyor…' : 'Giriş Yap'}
          </button>
        </form>

        <p className="text-white/30 text-xs text-center mt-6 tracking-wide">
          Yetkisiz erişim yasaktır.
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
